document.addEventListener('DOMContentLoaded', () => {
  const imageInput = document.getElementById('personalised-image');
  const preview = document.getElementById('image-preview');
  const widthInput = document.getElementById('image-width');
  const heightInput = document.getElementById('image-height');
  const textInput = document.getElementById('personalised-text');
  const counter = document.getElementById('char-count');
  const MAX_CHARS = 60;
  const MAX_SIZE = 5 * 1024 * 1024;

  if (imageInput) {
    imageInput.addEventListener('change', function () {
      const file = this.files[0];

      if (!file) return;

      if (file.size > MAX_SIZE) {
        alert('Image must be under 5MB');
        this.value = '';
        preview.style.display = 'none';
        return;
      }

      const reader = new FileReader();
      const img = new Image();

      reader.onload = (e) => {
        img.src = e.target.result;
      };
      img.onload = () => {
        widthInput.value = img.width;
        heightInput.value = img.height;

        preview.src = img.src;
        preview.style.display = 'block';
      };

      reader.readAsDataURL(file);
    });
  }

  if (textInput && counter) {
    textInput.addEventListener('input', () => {
      counter.textContent = textInput.value.length + ' / ' + MAX_CHARS;
    });
  }
});